import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PublishService, ProductService, LookupService } from '../../../services/models';
import * as moment from 'moment';


@Component({
  selector: 'app-publish-dialog',
  templateUrl: './publish-dialog.component.html',
  styleUrls: ['./publish-dialog.component.less']
})

export class PublishDialogComponent {
  parsedDate: Date;
  selectedDate: Date;
  selectedTime: string;
  schedule_uuid: any = null;
  publish_schedule: any = null;
  isPublishButtonDisabled: boolean = true;
  minDate: string;
  minTime: string; 
  
  constructor(
    private PublishService: PublishService,
    private dialogRef: MatDialogRef<PublishDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { draftrecordId: any, record?: any}
  ) {
    this.minDate = moment().format('YYYY-MM-DD');
    this.minTime = moment().format('HH:mm');
  }

  ngOnInit() {
    if (this.data.record && this.data.record.publish_schedule) {
      this.selectedDate = this.data.record.publish_schedule.slice(0, 10);
      this.selectedTime = this.data.record.publish_schedule.slice(11, 16);
      this.publish_schedule = this.data.record.publish_schedule;
      this.schedule_uuid = this.data.record.schedule_uuid;
      this.checkPublishButtonStatus();
    }
  }
  

  onDateChange(dateString: Date): void {
    const selectedDate = new Date(dateString);
    const minDate = moment().format('YYYY-MM-DD');

    if (moment(selectedDate).isSameOrAfter(minDate, 'day')) {
        this.selectedDate = dateString;
        this.checkPublishButtonStatus();
    } else {
        this.selectedDate = null;
        this.isPublishButtonDisabled = true;
    }
  }

  onTimeChange(time: string): void {
    this.selectedTime = time;
    this.checkPublishButtonStatus();
  }

  checkPublishButtonStatus(): void {
    this.isPublishButtonDisabled = !this.selectedDate || !this.selectedTime;
  }

  publish(): void {
    const result = {
      selectedDate: this.selectedDate,
      selectedTime: this.selectedTime,
      publishNow: false,
    };
    this.dialogRef.close(result);
  }

  publishNow(): void {
    const result = {
      publishNow: true,
    };
    this.dialogRef.close(result);
  }

  removeSchedule(): void {
    const result = {
      removeSchedule: true,
    };
    this.dialogRef.close(result);
  }

  cancel(): void {
    this.dialogRef.close();
  }
  
}
